// import Post from './Post';

export default {
  // component: Post,
  component: load(() => import(/* webpackChunkName: "Bulletin-Post" */ './Post')),
  priority: 9,
  permissions: ['PortalMenu/ContentMenu'],
  name: app.translate('routes.home.bulletin.Post'),
  icon: 'calendar-text',
  drawer: true,
};


